import React from "react";
import PropTypes from 'prop-types';

const BackArrow = ({
                       strokeColor = "#ffffff",
                       height = "16px",
                       width = "10px"
}) => {
    return (
        <svg version="1.1"  width={width} height={height} xmlns="http://www.w3.org/2000/svg">
            <g transform="matrix(1 0 0 1 -17 -20 )">
                <path
                    d="M 9.125 14.2224  C 9.45 14.5344  9.45 15.0416  9.125 15.3536  C 8.8 15.6656  8.27166666666666 15.6656  7.94666666666667 15.3536  L 0.875833333333333 8.5656  C 0.550833333333334 8.2536  0.550833333333334 7.7464  0.875833333333333 7.4344  L 7.94666666666667 0.646400000000001  C 8.27166666666667 0.334400000000001  8.8 0.334400000000001  9.125 0.646400000000001  C 9.45 0.958400000000001  9.45 1.4656  9.125 1.7776  L 2.64333333333333 8  L 9.125 14.2224  Z "
                    fillRule="nonzero" fill={strokeColor} stroke="none" transform="matrix(1 0 0 1 17 20 )"/>
            </g>
        </svg>
    )
}
BackArrow.propTypes = {
    strokeColor: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
}

export default BackArrow;